define(['jquery', 'jquery.history'], function ($) {
  var searchServiceGuids = new Array();
  var pageCount = parseInt($("#hiddenPageCount").text());
  var currentPage = 0;
  var totalExperiencesFound = 0;
  var experienceResults = new Array();
  var manualStateChange = true;

  LoadContent();

  (function (window, undefined) {
    // Define variables
    var History = window.History,
      State = History.getState();

    // Bind statechange event
    History.Adapter.bind(window, 'statechange', function () {
      var State = History.getState();
      if (manualStateChange == true) {
        LoadContent()
      }
      manualStateChange = true;
    });
  })(window)

  function updateFacadeText(facadeEl) {
    var $this = $(this),
      $selectedItem,
      $siblingEl,
      currentText;

    $selectedItem = $this.find(':selected');

    if (!$selectedItem.length) { return; }

    // get the facade element used to display
    // the text of the selected option
    $facadeEl = $this.siblings(facadeEl);

    // get 'value' attribute value for selected option
    currentText = $selectedItem.text();

    // update select text label with current selected option value
    if ($facadeEl.length && currentText.length) {
      $facadeEl.text(currentText);
    }
  }

  // execute this once the DOMContentLoaded has fired (dom ready)
  $(function (context, targetEl, facadeEl) {
    var $dropdowns = $(context).find(targetEl);
    var eventNamespace = context;

    if ($dropdowns.length) {
      $dropdowns
        .off(eventNamespace)
        .on('change' + eventNamespace, function () {

          updateFacadeText.call(this, facadeEl);
        })
    }

    GetAvailableFilters();
  }('.selector-ele', 'select', 'span'));

  $(".select-service").change(function () {
    $(".selected-matters").hide();
    $(".matters-search").show();

    var selectedOption = $(this).find("option:selected");
    $(this)
      .attr("disabled", "true")
      .parent().addClass('is-disabled');
    $(".form-results__criteria").append('<a role="button" data-parent-id=' + $(this).attr("id") + ' data-guid="' + $(selectedOption).attr("data-guid") + '" class="btn btn-grey  form-results__keyword" href="javascript:void(0)">' + $(selectedOption).text() + '</a>');

    currentPage = 0;

    GetSearchCriteria();
    GetAvailableFilters();
    BindRemoveCriteriaClick();
    UpdateHistory()
  });

  $(".form-results__clear").click(function () {
    searchServiceGuids = new Array();

    ResetSearch();
    GetAvailableFilters();
  });

  $(".btn-accordion.search").click(function () {
    ShowSearchResults();
  })

  function GetSearchCriteria() {
    $(".loading-image").show();
    $(".landing-lists").hide();

    searchServiceGuids = new Array();

    $(".select-service").each(function () {
      var selectedOption = $(this).find("option:selected");
      if (!$(selectedOption).hasClass("selector"))
        return;
      var obj = new Object();
      obj.Guid = $(selectedOption).attr("data-guid");
      searchServiceGuids.push(obj);
    })
  }

  function UpdateHistory() {
    var url = [location.protocol, '//', location.host, location.pathname].join('');
    var queryString = "";

    $(".form-results__criteria .form-results__keyword").each(function () {
      //get guid
      if (queryString == "")
        queryString = "?guids=" + $(this).attr("data-guid");
      else
        queryString += "," + $(this).attr("data-guid")
    })

    manualStateChange = false;

    if (queryString == "")
      History.pushState({ guids: searchServiceGuids }, $("head title").text(), url);
    else
      History.pushState({ guids: searchServiceGuids }, $("head title").text(), url + queryString);
  }

  function LoadContent() {
    var queryString = window.location.search;
    queryString = queryString.substring(1);
    var params = queryString.split("&");
    var guid;

    for (i = 0; i < params.length; i++) {
      var temp = params[i].split("=");
      guid = temp[1];
    }

    if (guid !== undefined) {
      $(".selected-matters").hide();
      $(".matters-search").show();

      var guidArray = guid.split(",");

      for (i = 0; i < guidArray.length; i++) {
        var selectedOption = $(".select-service").find("[data-guid='" + guidArray[i] + "']");

        $(".select-service")
          .attr("disabled", "true")
          .parent().addClass('is-disabled');

        $(selectedOption).prop("selected", true);
        $(".form-results__criteria").append('<a role="button" data-guid="' + $(selectedOption).attr("data-guid") + '" class="btn btn-grey  form-results__keyword" href="javascript:void(0)">' + $(selectedOption).text() + '</a>');
      }

      GetSearchCriteria();
      GetAvailableFilters();
      BindRemoveCriteriaClick();
    }
  }

  function ResetSearch() {
    $(".learn-more").hide();
    $(".form-results").hide();
    $(".articles-list").html("");
    $(".filtering.filtering--result-stat").hide();
    $(".form-results__keyword").remove();
    $(".select-service").each(function () {

      $(this).find("option[value='-1']").prop("selected", true);
      $(this)
        .removeAttr("disabled")
        .parent().removeClass('is-disabled');

      updateFacadeText.call(this, 'span');
    });

    $(".matters-search .mod-feature").fadeOut("slow", function () {
      $(".matters-search .mod-feature").html("");
    })

    $(".selector").show();
    $(".selected-matters").show();
    $(".matters-search").hide();

    currentPage = 0;
  }

  function GetAvailableFilters() {
    $(".matters-search .mod-feature").fadeOut("slow", function () {
      $(".matters-search .mod-feature").html("");
    }).promise().done(function () {
      if ($(".form-results__keyword").length == 0) {
        ResetSearch();
        $(".btn-accordion.search").hide();
      }

      ShowSearchResults();

      $.ajax({
        type: "POST",
        url: "/Layouts/WebUserControls/Main/Experience/ExperienceSearchService.asmx/GetPositionStatement",
        data: JSON.stringify({ searchServiceGuids: searchServiceGuids }), //add 1 so we can tell if there are more to load
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (response) {
          if (response.d.length == 1) {
            var statement = response.d[0].positionStatement;
            if (statement != "") {
              $(".matters-search .intro.mod-intro").html(statement);
              $(".matters-search .intro.mod-intro").show();
            }
            else
              $(".matters-search .intro.mod-intro").hide();
          }
          else {
            $(".matters-search .intro.mod-intro").hide();
          }

          $(".learn-more-link").html("");

          for (i = 0; i < response.d.length; i++) {
            $(".learn-more-link").append("<a class='read-more' href='" + response.d[i].url + "'>" + response.d[i].name + "</a><br />")
          }
        },
        error: function (xhr, ajaxOptions, thrownError) {

        }
      });
    });
  }

  function FilterFilters(serviceGuids) {
    $(".recent-listings").hide();

    //disable all selectors
    $(".selector").addClass("is-disabled");
    $(".select-service .selector").hide();

    //then reanable
    $(".selector").each(function () {
      if ($.inArray($(this).attr("data-guid"), serviceGuids) >= 0) {
        $(this).show();
        $(this).removeClass("is-disabled");
      }
    });

    $(".select-service").each(function () {
      if ($(this).children().not(".is-disabled").length == 1) {
        $(this)
          .attr("disabled", "true")
          .parent().addClass('is-disabled');
      }
    })
  }

  function ShowSearchResults() {
    $(".btn-accordion.search").hide();

    $.ajax({
      type: "POST",
      url: "/Layouts/WebUserControls/Main/Experience/ExperienceSearchService.asmx/FilterMenu",
      data: JSON.stringify({ searchServiceGuids: searchServiceGuids, skip: (currentPage * pageCount), take: pageCount }),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      success: function (response) {
        experienceResults = response.d.Experiences;
        currentPage = currentPage;
        pageCount = parseInt($("#hiddenPageCount").text());
        totalExperiencesFound = response.d.TotalExperiencesFound;

        if ((currentPage + 1) * pageCount < totalExperiencesFound) {
          $(".btn-accordion.search").show();
        }

        var guidArray = experienceResults.slice(0, pageCount);

        var ajaxUrl = "/Layouts/WebUserControls/Main/Experience/AjaxLoadListItems.aspx?guidArray=" + guidArray.join(",");
        $.ajax({ url: ajaxUrl })
          .done(function (p) {
            $(".matters-search .mod-feature").append(p);
            $(".matters-search .mod-feature").fadeIn();
            $(".form-results").show();
            $(".loading-image").hide();
          });

        currentPage++;
        $(".form-results").show();
        $(".filtering.filtering--result-stat").show();
        $(".learn-more").show();
        $(".loading-image").hide();

        FilterFilters(response.d.ServiceGuids);
        $(".filtering__results").text("Result(s): " + response.d.TotalExperiencesFound);

        UpdateHistory();
      },
      error: function (xhr, ajaxOptions, thrownError) {

      }
    });
  }

  function BindRemoveCriteriaClick() {
    //remove search
    $(".form-results__keyword").unbind();
    $(".form-results__keyword").click(function () {
      if ($(this).hasClass("keyword-field")) {
        $(".search-form__input").val("");
      }
      else {

        var dataGuid = $(this).attr("data-guid");
        $('[data-guid="' + dataGuid + '"]').removeClass("is-selected");
        var selector = $("#" + $(this).attr("data-parent-id")).find('[data-guid="' + dataGuid + '"]')
        $(selector).parent().removeAttr("disabled");
        $(selector).removeClass("is-selected");
        $(selector).parent().find("option[value='-1']").attr('selected', 'selected');
        $(selector).parent().find("option[value='-1']").prop('selected', 'true');

        updateFacadeText.call($(selector).parent(), 'span');
        $(selector).closest('.selector-ele').removeClass("is-disabled");
      }

      $(this).remove();
      currentPage = 0;
      GetSearchCriteria();
      GetAvailableFilters()
    })
  }
});